// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__LbXQj","notes":"Notes_notes__tNo01","note":"Notes_note__kFQes","markdown":"Notes_markdown__ki0nE"};